/* istanbul ignore file */
import { number as codecNumber, string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const InlineFeedbackExtraParser = /* #__PURE__ */ parsers.object([
    ['type', /* #__PURE__ */ parsers.exactly('inline-feedback')],
    ['line', codecNumber],
    ['fileId', codecString, 'file_id'],
]);
export class InlineFeedbackExtra extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return InlineFeedbackExtraParser.decode(input).map(res => new InlineFeedbackExtra(res));
    }
    static unsafeDecode(input) {
        return InlineFeedbackExtra.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return InlineFeedbackExtraParser.encode(data);
    }
    static schema() {
        return InlineFeedbackExtraParser.schema();
    }
}
